module.exports = __webpack_public_path__ + "static/media/7.Highlighted Spread.393a29ec.jpg";